import aT from '../const/action-type'
import initial from '../store/initial'
//
export default (state = initial.location, action) => {
  switch (action.type) {
    case aT.SET_LOCATION:
      return action.data
    case aT.RESET_STORE:
      return initial.location
    case aT.SWITCH_WORKSPACE:
      return initial.location
    default:
      return state
  }
}
